import styled from 'styled-components';

const ContentWrapper = styled.div`
  background: none;
  height: 100%;
  min-height: 200px;
  width: 700px;
  .smallTextField {
    .Superops-TextField {
      width: 60px;
    }
  }
`;

const SuffixWrapper = styled.div`
  width: ${(props) => (props?.adaptWidth ? '100%' : '65px')};
  line-height: ${(props) => (props?.adaptHeight ? '1' : '2')};
  background: #eee;
  margin-top: 5px;
  border-radius: 5px 5px 0px 0px;
  text-align: center;
  padding: ${(props) => (props?.adaptWidth ? '0px 10px' : '0px 5px')};
`;
export { ContentWrapper, SuffixWrapper };
